import { FC } from "react";
import { ListType, Role } from "routes/analysis/types/analysis";
import { TestData } from "routes/analysis/types/user";
import UserMatches from "../../user/userMatches";

const RoleMatches: FC<{ role: Role, test: TestData }> = ({ role, test }) => {
  return (
    <UserMatches
      type={role.isComposite ? ListType.CompositeRole : ListType.Role}
      typeId={role.roleId}
      matchingData={{ roles: [role], tests: [test], profiles: [] }}
    />
  );
};

export default RoleMatches;
